import { clientTranslator } from '@adornis/translation-core/client/clientTranslator.js';
import { globalLanguageSubject } from '@adornis/translation-core/client/languageSubject.js';
import { Language } from '@adornis/translation-core/languages.js';
import * as trans from '../translation-data.js';

export const languages = {
  german: Language.GERMAN,
  english: Language.ENGLISH,
};

export const productFieldTranslation = trans.productFieldTranslation;
export const butFieldTranslation = trans.butFieldTranslation;
export const translationData = trans.translationData;

clientTranslator.updateDictionary(translationData, [Language.GERMAN, Language.ENGLISH]);

// in ChancenRaum, always use German
globalLanguageSubject.next(Language.GERMAN);
